import { render } from "./ZamgPin.vue?vue&type=template&id=6c98589a&ts=true"
import script from "./ZamgPin.vue?vue&type=script&lang=ts"
export * from "./ZamgPin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__